import { invariant } from '@mimir/common/util/invariant';
import { evalRawScript, getFresh } from './cep';
import type { AllNleActions, ICepBridgeClient } from '@mimir/primitive/premiere/cepBridgeClientType';
import { createSourceLocationResolver } from '../nle/adapters/cep/extendScriptSourceLocation';
import type { SourceLocationResolver } from '../nle/adapters/cep/extendScriptSourceLocation';
import { extendScriptCallError, parseExtendScriptCallReply } from '../nle/adapters/cep/extendScriptError';

const CEPBRIDGE_BUNDLE_PATH = '/assets/cepbridge.jsx';

export class CepBridgeClient implements ICepBridgeClient {
  initialized: boolean = false;
  private readonly resolveSourceLocation: SourceLocationResolver = createSourceLocationResolver(CEPBRIDGE_BUNDLE_PATH);

  async call<A extends keyof AllNleActions>(action: A, ...args: Parameters<AllNleActions[A]>): Promise<ReturnType<AllNleActions[A]>> {

    if (!this.initialized) {

      const bundle: string = await getFresh(CEPBRIDGE_BUNDLE_PATH);
      const s = bundle.lastIndexOf('[') + 1;
      const e = bundle.indexOf(']', s);
      const id = bundle.slice(s, e);
      const initScript = '__require=' + bundle + ';cepbridge=__require(' + id + '); "OK"';
      const result = await evalRawScript(initScript);
      invariant(result == 'OK', `Expected initialized cepbridge, got: ${result}`);
      this.initialized = true;
    }

    const argsJson = JSON.stringify(args);
    const callScript = 'cepbridge.call(' + JSON.stringify(action) + ',' + argsJson + ');';
    const reply = await evalRawScript(callScript);
    const obj = parseExtendScriptCallReply(reply, `cepbridge.call('${action}')`);
    if (obj.error) {
      throw await extendScriptCallError(obj.error, action, args, this.resolveSourceLocation);
    }
    return obj.result as ReturnType<AllNleActions[A]>;
  }
}
